export const initialState = {
  theme: 'light',
  partners: [],
};

function reducer(state, action) {
  switch (action.type) {
    case 'SET_PARTNERS':
      return {
        ...state,
        partners: action.data,
      };
    case 'TOGGLE_THEME':
      return {
        ...state,
        theme: state.theme === 'dark' ? 'light' : 'dark',
      };
    case 'SET_THEME_DARK':
      return {
        ...state,
        theme: 'dark',
      };
    default:
      return state;
  }
}

export default reducer;




// WEBPACK FOOTER //
// ./src/store/reducer.js